<div *ngIf="loadCompleted && reportModels.length === 0" class="rollup-report-view__empty">
    {{ 'NO_REPORT_DATA' | translate }}
</div>

<ng-container *ngIf="reportModels.length > 0">
    <section class="rollup-metrics-section rollup-metrics-section--combined">
        <div class="rollup-metrics-section__heading">
            <h3>{{ 'TOTALS' | translate }}</h3>
            <span class="rollup-metrics-section__date-range">
                {{ 'DATE_RANGE' | translate }} {{ iRollupReportDataResponse?.dateStart | date:'MM/dd/yyyy' }} - {{ iRollupReportDataResponse?.dateStop | date:'MM/dd/yyyy' }}
            </span>
        </div>
        <div class="rollup-metrics-grid">
            <div class="rollup-metric-card"><span>{{ 'CAMPAIGNS' | translate }}</span><strong>{{ combinedSummary.campaigns | number }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'SPEND' | translate }}</span><strong>{{ combinedSummary.spend | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ (isLeadOnlySelection ? 'LEADS' : 'CONVERSIONS') | translate }}</span><strong>{{ combinedSummary.leads | number }}</strong></div>
            <div class="rollup-metric-card"><span>{{ (isLeadOnlySelection ? 'CPL' : 'CPA') | translate }}</span><strong>{{ combinedSummary.cpl | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ (isLeadOnlySelection ? 'LSR' : 'CONV_PERCENT') | translate }}</span><strong>{{ combinedSummary.lsr | percent:'1.2-2' }}</strong></div>
        </div>
    </section>
<!--
    <section *ngIf="hasMetaPlatform" class="rollup-metrics-section rollup-metrics-section--meta">
        <h3>{{ 'PLATFORMS.META' | translate }}</h3>
        <div class="rollup-metrics-grid">
            <div class="rollup-metric-card"><span>{{ 'CAMPAIGNS' | translate }}</span><strong>{{ metaSummary.campaigns | number }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'SPEND' | translate }}</span><strong>{{ metaSummary.spend | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'CPM' | translate }}</span><strong>{{ metaSummary.cpm | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'CTR' | translate }}</span><strong>{{ metaSummary.ctr | percent:'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'LEADS' | translate }}</span><strong>{{ metaSummary.leads | number }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'CPL' | translate }}</span><strong>{{ metaSummary.cpl | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'LSR' | translate }}</span><strong>{{ metaSummary.lsr | percent:'1.2-2' }}</strong></div>
        </div>
    </section>

    <section *ngIf="hasGooglePlatform" class="rollup-metrics-section rollup-metrics-section--google">
        <h3>{{ 'PLATFORMS.GOOGLE' | translate }}</h3>
        <div class="rollup-metrics-grid">
            <div class="rollup-metric-card"><span>{{ 'CAMPAIGNS' | translate }}</span><strong>{{ googleSummary.campaigns | number }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'SPEND' | translate }}</span><strong>{{ googleSummary.spend | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'CPC' | translate }}</span><strong>{{ googleSummary.cpc | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'CTR' | translate }}</span><strong>{{ googleSummary.ctr | percent:'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'LEADS' | translate }}</span><strong>{{ googleSummary.leads | number }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'CPL' | translate }}</span><strong>{{ googleSummary.cpl | currency:'USD':'symbol':'1.2-2' }}</strong></div>
            <div class="rollup-metric-card"><span>{{ 'LSR' | translate }}</span><strong>{{ googleSummary.lsr | percent:'1.2-2' }}</strong></div>
        </div>
    </section>
-->
</ng-container>

<div *ngIf="reportModels.length > 0" class="rollup-report-view__platforms">
    <div class="section-tabs-rail rollup-report-view__tab-rail" role="tablist" aria-label="Rollup report platforms">
        <button
            *ngIf="hasMetaPlatform"
            type="button"
            class="section-tab-button"
            [class.section-tab-button--active]="activePlatform === 'meta'"
            (click)="activePlatform = 'meta'"
            role="tab"
            [attr.aria-selected]="activePlatform === 'meta'">
            <h2>{{ 'PLATFORMS.META' | translate }}</h2>
        </button>
        <button
            *ngIf="hasGooglePlatform"
            type="button"
            class="section-tab-button"
            [class.section-tab-button--active]="activePlatform === 'google'"
            (click)="activePlatform = 'google'"
            role="tab"
            [attr.aria-selected]="activePlatform === 'google'">
            <h2>{{ 'PLATFORMS.GOOGLE' | translate }}</h2>
        </button>
    </div>

    <ng-container *ngFor="let reportModel of reportModels">
        <ng-container *ngIf="platformKey(reportModel.Platform) === activePlatform">
            <div *ngIf="hasMultipleConversionActionsForPlatform(activePlatform)" class="report-view-panel datatable-page-surface" style="margin-top:8px; padding:10px;">
                <label class="report-view-form-label">{{ 'CONVERSION_ACTIONS_INCLUDED' | translate }}</label>
                <div style="display:flex; flex-wrap:wrap; gap:10px;">
                    <div *ngFor="let action of getConversionActionsForPlatform(activePlatform)" class="form-check" style="margin-right:12px;">
                        <input class="form-check-input" type="checkbox" [id]="'rollup-conv-' + activePlatform + '-' + action.key"
                            [checked]="selectedConversionActionsByPlatform[activePlatform].includes(action.key)"
                            (change)="toggleSelectedConversion(activePlatform, action.key)">
                        <label class="form-check-label" [for]="'rollup-conv-' + activePlatform + '-' + action.key">
                            {{ action.labelKey | translate }} <small>({{ action.value | number }})</small>
                        </label>
                    </div>
                </div>
            </div>
        </ng-container>
        <app-report-view
            [hidden]="platformKey(reportModel.Platform) !== activePlatform"
            [iReportData]="reportModel"
            [iReportName]="iRollupReportDataResponse?.company?.name || reportModel.CampaignName"
            [iIsRollupReport]="true"
            [iShowControls]="false"
            [iSelectedConversionActions]="selectedConversionActionsByPlatform[platformKey(reportModel.Platform)]">
        </app-report-view>
    </ng-container>
</div>
